import { render } from "./QuizScoreEditor.vue?vue&type=template&id=0b3be141&scoped=true"
import script from "./QuizScoreEditor.vue?vue&type=script&lang=js"
export * from "./QuizScoreEditor.vue?vue&type=script&lang=js"

import "./QuizScoreEditor.vue?vue&type=style&index=0&id=0b3be141&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3be141"]])

export default __exports__